$(document).on('turbo:load', ()=> {
  if ($("#dashboard-container").length) { new Dashboard($("#dashboard-container")); }
});

class Dashboard {
  constructor(element) {
    this.init_posts_overview_panel = this.init_posts_overview_panel.bind(this);
    this.init_posts_overview_modals = this.init_posts_overview_modals.bind(this);
    this.init_posts_overview_user_select = this.init_posts_overview_user_select.bind(this);
    this.init_on_the_radar_panel = this.init_on_the_radar_panel.bind(this);
    this.init_calendar_filter = this.init_calendar_filter.bind(this);
    this.refresh_posts_overview = this.refresh_posts_overview.bind(this);
    this.load_on_the_radar_list = this.load_on_the_radar_list.bind(this);
    this.container = element;
    this.calendarId = null;
    this.init_calendar_filter();
    this.init_posts_overview_panel();
    this.init_on_the_radar_panel();
  }

  init_calendar_filter() {
    const filterContainer = this.container.find("#dashboard-calendar-filter");
    if (!filterContainer.length) return;

    this.calendarId = filterContainer.data("default-calendar") || null;

    this._onCalendarFilterChanged = (e) => {
      this.calendarId = e.detail.calendarId;
      this.refresh_posts_overview();
      this.load_on_the_radar_list();
    };

    document.addEventListener("dashboard-calendar-filter-changed", this._onCalendarFilterChanged);

    $(document).one('turbo:before-visit', () => {
      document.removeEventListener("dashboard-calendar-filter-changed", this._onCalendarFilterChanged);
    });
  }

  refresh_posts_overview() {
    const assigned_to_id = this.container.find('.dropdown-menu .selected').data('user');
    const params = {};
    if (this.calendarId) params.calendar_id = this.calendarId;
    if (assigned_to_id) params.assigned_to_id = assigned_to_id;

    $.get("/dashboard/posts_overview_container", params, data => {
      this.container.find("#posts-overview-container").replaceWith(data).find('[data-toggle="tooltip"]').tooltip();
      this.init_posts_overview_modals();
    });
  }

  init_posts_overview_panel() {
    this.init_posts_overview_modals();
    this.init_posts_overview_user_select();

    const panel = this.container.find("#posts-overview-panel");

    panel.find(".dashboard-user-filter select").on("change", e => {
      const assigned_to_id = panel.find(".dashboard-user-filter select").val();
      const params = { assigned_to_id };
      if (this.calendarId) params.calendar_id = this.calendarId;
      $.get("/dashboard/posts_overview_container", params, data=> {
        panel.find("#posts-overview-container").replaceWith(data).find('[data-toggle="tooltip"]').tooltip();
      });
    });
  }

  init_posts_overview_modals() {
    const panel = $('.posts-overview-row');
    const _this = this;

    panel.on('click', function(e) {
      const { state } = e.currentTarget.dataset;
      const modal_to_open = '#' + state + '-posts';

      $(modal_to_open).modal().show();

      const params = { state, assigned_to_id: $('.dropdown-menu .selected').data('user') };
      if (_this.calendarId) params.calendar_id = _this.calendarId;

      $.get('/dashboard/posts_overview_list', params).then(data => {
        const container = $('.posts-list-container');
        container.html(data).find('[data-toggle="tooltip"]').tooltip();
        $('.posts-list-loading').remove();
      });
    });
  }

  init_posts_overview_user_select() {
    const _this = this;
    const user_selection = $('.js-filter-user-dropdown');

    user_selection.on('click', function() {
      const element = $(this);
      const user = element.data('user');
      $('.dropdown-menu .selected').removeClass('selected');
      element.addClass('selected');

      if (user) {
        $('.icon-filter').addClass('enabled');
      } else {
        $('.icon-filter').removeClass('enabled');
      }

      const params = { assigned_to_id: user };
      if (_this.calendarId) params.calendar_id = _this.calendarId;

      $.get('/dashboard/posts_overview_container', params).then(data => {
        $('#posts-overview-container').replaceWith(data).find('[data-toggle="tooltip"]').tooltip();
        _this.init_posts_overview_modals();
      });
    });
  }

  init_on_the_radar_panel() {
    const panel = this.container.find("#on-the-radar-panel");

    panel.on("click", ".load-on-the-radar-list", e=> {
      e.preventDefault();
      const link = $(e.currentTarget);
      if (link.hasClass("is-disabled")) return;
      this.load_on_the_radar_list(link.attr("data-date"));
    });

    panel.find(".dashboard-calendar-filter select").on("change", e=> {
      this.load_on_the_radar_list();
    });
  }

  load_on_the_radar_list(date) {
    const panel = this.container.find("#on-the-radar-panel");
    const calendar_id = this.calendarId || panel.find(".dashboard-calendar-filter select").val();
    if (!date) { date = panel.find("#on-the-radar-contents").attr("data-date"); }

    const params = { date };
    if (calendar_id) params.calendar_id = calendar_id;

    $.get("/dashboard/on_the_radar_list", params, data=> {
      panel.find("#on-the-radar-contents").attr("data-date", date).html(data).find('[data-toggle="tooltip"]').tooltip();
    });
  }
}
